var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telegram-light@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4EA4\\u6613",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1687021,16.9151278 L21.4093227,1.63874293 C21.6958541,0.294379398 20.9241193,-0.234705458 20.0423916,0.095466253 L0.996252972,7.43586764 C-0.304614888,7.9423849 -0.281999066,8.67043112 0.776025982,9.00040995 L5.64773441,10.5213119 L16.9567544,3.4008964 C17.4858875,3.04830176 17.9710909,3.2472149 17.5748077,3.59980955 L8.42706943,11.8658201 L8.07423367,16.8925602 C8.58075093,16.8925602 8.8022799,16.6725261 9.06614723,16.4073086 L11.4461611,14.1147201 L16.3839328,17.751865 C17.2882763,18.2583823 17.9274024,17.9944667 18.1701969,16.9138259 L18.1687021,16.9151278 Z",
    id: "telegram-light",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLight);
export default __webpack_public_path__ + "static/media/telegram-light.962a0238a55367c1c133b2e885a083b8.svg";
export { ForwardRef as ReactComponent };